import React from "react"
import { useTranslation } from "react-i18next"

import { Offcanvas } from "shared/ui/offcanvas/Offcanvas"
import { Tooltip } from "shared/ui/tooltip/Tooltip"

import { usePreventWindowScroll } from "features/scroll-management/model/usePreventWindowScroll"

import { AppSidebarViewModel } from "../model/useAppSidebarViewModel"
import { AppSidebarContent } from "./AppSidebarContent"

export const AppSidebarMobile = React.memo((viewModel: AppSidebarViewModel) => {
  const { t } = useTranslation()
  const { isOpen, onClose, inert } = viewModel

  usePreventWindowScroll({ id: "app-sidebar-mobile", isScrollDisabled: isOpen })

  return (
    <Offcanvas
      id="app-sidebar-mobile"
      // Offcanvas renders role="dialog" aria-modal, which requires an
      // accessible name. The panel has no visible heading (hideHeader).
      aria-label={t("Menu.Menu")}
      className="app-sidebar app-sidebar-mobile"
      data-testid="app-sidebar"
      data-sidebar-variant="mobile"
      show={isOpen}
      onHide={onClose}
      placement="start"
      scroll
      inert={inert}
      backdropClassName="app-sidebar-mobile__backdrop"
    >
      <Tooltip.Provider disabled={isOpen}>
        <AppSidebarContent {...viewModel} hideHeader />
      </Tooltip.Provider>
    </Offcanvas>
  )
})
